import type { WaitingRow } from '@/api'

/**
 * How a Waiting row's last run ended, in words (#1457). The API sends the run's terminal status, or
 * `decision_rejected` when a rejected decision is what ended it; anything newer reads as itself rather than blank.
 */
const ENDED_AS: Record<string, string> = {
    succeeded: 'Succeeded, work left open',
    failed: 'Failed, then cleared',
    cancelled: 'Cancelled',
    decision_rejected: 'Decision rejected',
}

export function waitingEndedLabel(endedAs: string): string {
    return ENDED_AS[endedAs] ?? endedAs.replaceAll('_', ' ')
}

/**
 * What a Waiting row's work is called: an issue or pull request by its pipeline key (`owner/name#<number>`), a work
 * item by its title, or by its key when the item is gone (#1829).
 */
export function waitingWorkLabel(row: Pick<WaitingRow, 'pipeline' | 'workItem' | 'workItemTitle'>): string {
    if (!row.workItem) {
        return row.pipeline
    }
    const title = row.workItemTitle?.trim() ?? ''
    return title === '' ? row.pipeline : title
}
